// extracted by mini-css-extract-plugin
export default {"tabContainer":"tabs_tabContainer__XvWWP","tab":"tabs_tab__v16Ec","tabSpacer":"tabs_tabSpacer__E2Fwa","active":"tabs_active__qoTc0"};